'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { env } from '@cc-shopping/platform-env';
import { Button } from '@mui/material';
import { ENTRYPOINT_ENTITY_NAME, ENTRYPOINT_SECTION_NAME } from './constants';
type Props = {
  activityId: string;
};
export function GetMatchedButton(t0) {
  const $ = _c(7);
  const {
    activityId
  } = t0;
  let t1;
  if ($[0] !== activityId) {
    t1 = {
      actionName: ENTRYPOINT_ENTITY_NAME,
      actionType: "click",
      actionSection: ENTRYPOINT_SECTION_NAME,
      actionInput: "Get Matched",
      parentActivityId: activityId
    };
    $[0] = activityId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firePageAction = usePageAction(t1);
  let t2;
  if ($[2] !== firePageAction) {
    t2 = () => firePageAction();
    $[2] = firePageAction;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      bgcolor: "lime.tintLP",
      color: "primary.main",
      borderRadius: 1,
      py: 1.5,
      px: 4,
      letterSpacing: "0.05em",
      lineHeight: 1.5,
      boxShadow: "none",
      fontWeight: 700,
      whiteSpace: "nowrap",
      "&:hover": {
        bgcolor: "lime.main",
        boxShadow: "none"
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Button href={`${env.NEXT_PUBLIC_NW_URL}/credit-cards/cardfinder`} onClick={t2} variant="contained" component="a" fullWidth={false} sx={t3}>GET MATCHED</Button>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}